import React from 'react';
import './ChatComponents.css';

interface UserBubbleProps {
    message: { content: string };
    userInitial?: string;
}

const UserBubble = ({ message, userInitial = 'U' }: UserBubbleProps) => {
    return (
        <div style={{ display: 'flex', width: '100%', gap: '16px' }}>
            <div className="message-avatar message-avatar-user" title="You">
                {userInitial.toUpperCase()}
            </div>
            <div className="message-content">
                {message.content}
            </div>
        </div>
    )
}

export default UserBubble;